import { useCallback } from 'react';
import { useTheme } from 'styled-components';
import { DesignToken } from '../types';
import { getToken } from '../utils/getToken';

export const useGetToken = () => {
    const theme = useTheme();
    return useCallback(<T extends DesignToken>(tokenName: T) => getToken(tokenName)({ theme }), [theme]);
};

export const useToken = <T extends DesignToken>(tokenName: T) => {
    const theme = useTheme();
    return getToken(tokenName)({ theme });
};
